export default {
  SET_MAX_COUPONS_NUM: 'SET_MAX_COUPONS_NUM',
  SET_ORDER_PROPS: 'SET_ORDER_PROPS',
  ON_SELECT_WHOLE_BENEFIT: 'ON_SELECT_WHOLE_BENEFIT',
  CLOSE_WHOLE_BENEFIT_SELECT: 'CLOSE_WHOLE_BENEFIT_SELECT',
  CHANGE_PURCHARSE_DISH: 'CHANGE_PURCHARSE_DISH',
  SET_PURCHASE_RULE_ITEMS: 'SET_PURCHASE_RULE_ITEMS',
  CHANGE_ACTIVE_PURCHASE_BENEFIT: 'CHANGE_ACTIVE_PURCHASE_BENEFIT',
  CONFIRM_CHOSEN_PURCHASE_BENEFIT: 'CONFIRM_CHOSEN_PURCHASE_BENEFIT',
  SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT: 'SAME_COUNT_WITH_ORDER_PURCHASE_BENEFIT',
};



// WEBPACK FOOTER //
// ./src/consts/order-action-type.js